import client from "../client";

type Constructor<T> = new () => T;

export abstract class BaseService {
  private static instances = new Map<object, BaseService>();

  protected static getInstance<T extends BaseService>(this: Constructor<T>): T {
    if (!BaseService.instances.has(this)) {
      BaseService.instances.set(this, new this());
    }
    return BaseService.instances.get(this) as T;
  }

  protected get client() {
    return client.getInstance();
  }
}
